import { ABOUT_BG } from "../lib/config";
import { Truck, Package, ShieldCheck, Clock } from "lucide-react";

const items = [
    {
        icon: Truck,
        title: "Local Delivery",
        body: "Door-to-door across South Jersey. Same-day on most orders. Hit us on Telegram with your zip and we'll route you.",
        accent: "text-highway-red",
        bgClass: "bg-highway-red/10 border-highway-red/30",
    },
    {
        icon: Package,
        title: "Discreet Drops",
        body: "Vacuum-sealed and odor-proof. We meet you where you're posted up — driveway, parking lot, the corner. Your call.",
        accent: "text-highway-blue",
        bgClass: "bg-highway-blue/10 border-highway-blue/30",
    },
    {
        icon: ShieldCheck,
        title: "Premium THCA",
        body: "Lab-tested, hemp-derived THCA flower & concentrates. Federally compliant, slow-cured, properly stored.",
        accent: "text-emerald-400",
        bgClass: "bg-emerald-500/10 border-emerald-500/30",
    },
    {
        icon: Clock,
        title: "Always Open",
        body: "Telegram is on the dash 24/7. Drop a message — we'll cruise back fast with availability and pricing.",
        accent: "text-highway-sunset",
        bgClass: "bg-highway-sunset/10 border-highway-sunset/30",
    },
];

export default function HowItWorks() {
    return (
        <section
            data-testid="delivery-section"
            id="delivery"
            className="relative py-20 sm:py-28 overflow-hidden"
        >
            {/* Background image strip */}
            <div className="absolute inset-x-0 top-0 h-[40%] -z-0">
                <img
                    src={ABOUT_BG}
                    alt=""
                    className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-b from-background/40 via-background/80 to-background" />
            </div>

            <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="max-w-2xl">
                    <p className="font-mono text-xs uppercase tracking-[0.3em] text-highway-blue mb-3">
                        // The Route
                    </p>
                    <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-white tracking-tighter text-balance">
                        One lane.{" "}
                        <span className="italic font-light text-white/80">
                            One destination.
                        </span>
                    </h2>
                    <p className="mt-4 text-white/65 text-lg">
                        We run South Jersey only — fast, discreet, and
                        on-schedule. No tickets, no detours.
                    </p>
                </div>

                {/* Bento */}
                <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
                    {items.map((it, i) => {
                        const Icon = it.icon;
                        return (
                            <div
                                key={it.title}
                                data-testid={`feature-${it.title.toLowerCase().replace(/\s+/g, "-")}`}
                                className={`relative rounded-2xl p-7 border bg-card hover:bg-card/80 transition-colors fade-up ${
                                    i === 0 || i === 3
                                        ? "lg:row-span-1 lg:col-span-1"
                                        : ""
                                }`}
                                style={{ animationDelay: `${0.08 * i}s` }}
                            >
                                <div
                                    className={`w-12 h-12 rounded-xl border flex items-center justify-center mb-5 ${it.bgClass}`}
                                >
                                    <Icon className={`w-5 h-5 ${it.accent}`} />
                                </div>
                                <h3 className="font-display text-xl font-semibold text-white mb-2">
                                    {it.title}
                                </h3>
                                <p className="text-sm text-white/60 leading-relaxed">
                                    {it.body}
                                </p>
                                <p
                                    className={`absolute top-6 right-6 font-mono text-[10px] uppercase tracking-widest ${it.accent} opacity-60`}
                                >
                                    0{i + 1}
                                </p>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
